import React, { useState, useRef } from "react";
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import DescriptionIcon from '@material-ui/icons/Description';
import { translation, ConfirmModal } from "@carrier-ecat/ngecat-reactcomponents";
import "./UnitCalculator.scss";
import calculatorConfigData  from "./Calculator";
import UnitConvertorControl from "./unitConvertorControl";

const UnitConversionCalculator = () => {
  const node = useRef();
  const unitConversionList = JSON.parse(JSON.stringify(calculatorConfigData));
  const [openDialouge, setOpenDialouge] = useState(false);
  const hasPermission = true;
  const toggleDialog = () => {
    setOpenDialouge(false);
  };

  return (
		hasPermission && (
			<div
				ref={node}
				className='dropdown'
				key='calculator'
				id='calculator'
			>
				<Tooltip title={translation('UnitCalculator')}>
					<IconButton
						disabled={true}
						role='button'
						className='dropdown-toggler'
						onClick={(e) => setOpenDialouge(true)}
					>
						<DescriptionIcon />
					</IconButton>
				</Tooltip>

				{openDialouge && (
					<ConfirmModal
						className='box'
						isModalOpen
						title={translation('UnitConversionCalculator')}
						hideCancel={false}
						id='UnitCalculator'
						key='UnitCalculator'
						onClose={toggleDialog}
					>
						<div className='unitConvertor-control-container'>
							{unitConversionList.Units.map((unit) => {
								return (
									<UnitConvertorControl
										key={unit.id}
										unit={unit}
									></UnitConvertorControl>
								);
							})}
						</div>
					</ConfirmModal>
				)}
			</div>
		)
  );
};

export default React.memo(UnitConversionCalculator);
